// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../../../common/util.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function InternationalHeader(props) {
  return JsxRuntime.jsx("h1", {
              children: Util.ReactStuff.s("Buying eGift cards for someone overseas?"),
              className: "text-left xs:text-center text-3xl md:text-4xl font-bold mt-10 md:mt-20"
            });
}

var make = InternationalHeader;

export {
  make ,
}
/* Util Not a pure module */
